import React from 'react'
import { Pane } from 'evergreen-ui'
import { useCustomTheme } from '/fiweb/lib/theme'

import Upcoming from './Upcoming'
import Finished from './Finished'
import Ongoing from './Ongoing'
import ComingSoon from './ComingSoon'

const AllCampaigns = () => {
  const theme = useCustomTheme()
  return (
    <Pane width='100%' display='flex' flexDirection='column' alignItems='center'>
      <Pane backgroundColor={theme.colors.fiTint} width='100%'>
        <Ongoing />
      </Pane>
      <Pane backgroundColor={theme.colors.fiTint} width='100%'>
        <Upcoming />
      </Pane>
      <Pane backgroundColor={theme.colors.fiTint} width='100%'>
        <ComingSoon />
      </Pane>
      <Pane backgroundColor={theme.colors.fiTint} width='100%'>
        <Finished />
      </Pane>
    </Pane>
  )
}

export default AllCampaigns
